var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoldiers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6D5990",
    d: "M24.746 25.204v2.063c0 .569-.46 1.03-1.031 1.03H1.031c-.57 0-1.031-.461-1.031-1.03v-2.063c0-4.588 2.52-8.693 6.399-10.826 1.504 1.583 3.623 2.578 5.974 2.578s4.47-.995 5.974-2.578c3.878 2.133 6.4 6.238 6.4 10.826",
    transform: "translate(.114 .808)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5990",
    d: "M18.468 7.675c.059.336.092.68.092 1.032 0 3.416-2.77 6.186-6.187 6.186-3.417 0-6.187-2.77-6.187-6.186 0-.352.033-.696.092-1.032h12.19z",
    transform: "translate(.114 .808)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M18.89 2.253V2.25L7.65.073 7.567.057 7.495.043v.003C7.325.018 7.153 0 6.975 0 5.217 0 3.792 1.426 3.792 3.184c0 1.76 1.425 3.184 3.185 3.184H18.56c1.145 0 2.072-.928 2.072-2.071 0-1.033-.755-1.886-1.742-2.044",
    transform: "translate(.114 .808)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9B5E6",
    d: "M8.182 3.487c0 .677-.549 1.226-1.225 1.226-.677 0-1.226-.55-1.226-1.226 0-.677.549-1.226 1.226-1.226.676 0 1.225.55 1.225 1.226",
    transform: "translate(.114 .808)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldiers);
export default __webpack_public_path__ + "static/media/soldiers.be14e2ecbe4b7c78962bf2af0fa12e0a.svg";
export { ForwardRef as ReactComponent };